import { render } from "./AuthNotAllowed.vue?vue&type=template&id=1d1616f3&scoped=true"
import script from "./AuthNotAllowed.vue?vue&type=script&lang=js"
export * from "./AuthNotAllowed.vue?vue&type=script&lang=js"

import "./AuthNotAllowed.vue?vue&type=style&index=0&id=1d1616f3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d1616f3"]])

export default __exports__